import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { useState } from "react"
import {
	CACHE_GC_TIME,
	CACHE_REFETCH,
	CACHE_STALE_TIME,
} from "@/config/constants"

interface QueryProviderProps {
	children: React.ReactNode
}

export function QueryProvider({ children }: QueryProviderProps) {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						staleTime: CACHE_STALE_TIME.DEFAULT,
						gcTime: CACHE_GC_TIME.DEFAULT,
						retry: CACHE_REFETCH.RETRY,
						refetchOnWindowFocus: CACHE_REFETCH.ON_WINDOW_FOCUS,
					},
					mutations: {
						retry: false,
					},
				},
			}),
	)

	return (
		<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
	)
}

export const Provider = QueryProvider
